import { Avatar } from 'avatar-components/Avatar';
import { Flex } from 'foundations-components/components/Flex';
import { CRM_OBJECT_TYPE_IDS } from 'personalization-lib/constants/objectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders the logo of the targeted company, or the avatar of the targeted contact, through the
 * shared avatar service. The service resolves the record's own image and falls back to an
 * initialled placeholder, so a target without an uploaded image is still identifiable.
 */
const CrmObjectAvatar = ({
  objectTypeAndId: {
    objectTypeId,
    objectId
  },
  displayName,
  size = '40px'
}) => {
  const isCompany = objectTypeId === CRM_OBJECT_TYPE_IDS.COMPANY;
  const isContact = objectTypeId === CRM_OBJECT_TYPE_IDS.CONTACT;
  if (!isCompany && !isContact) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    inlineSize: size,
    blockSize: size,
    flexShrink: 0,
    "data-test-id": "crm-object-avatar",
    children: /*#__PURE__*/_jsx(Avatar, Object.assign({
      size: "responsive",
      type: isCompany ? 'company' : 'contact',
      displayName: displayName
    }, isCompany ? {
      companyId: Number(objectId)
    } : {
      vid: Number(objectId)
    }))
  });
};
export default CrmObjectAvatar;